export default __webpack_public_path__ + "static/media/1BHK B (WS).99b1c142.png";